<template>
	<v-modal>
		<template v-slot:header>
			<h1>Upload search pack</h1>
			<h2 class="beta" v-html="instruction.address.asLine"/>
		</template>
		<!--		<loader v-if="!formReady"/>-->
		<!--		<template v-else>-->
		<!--			&lt;!&ndash;			<template v-if="$can('selectBundle', searchPack)">&ndash;&gt;-->
		<!--			&lt;!&ndash;				<div>&ndash;&gt;-->
		<!--			&lt;!&ndash;					Risks&ndash;&gt;-->
		<!--			&lt;!&ndash;					<div class="alert alert&#45;&#45;warning">&ndash;&gt;-->
		<!--			&lt;!&ndash;						<ul>&ndash;&gt;-->
		<!--			&lt;!&ndash;							<li v-for="(risk, riskIndex) in searchPack.risks" :key="riskIndex" v-html="risk"/>&ndash;&gt;-->
		<!--			&lt;!&ndash;						</ul>&ndash;&gt;-->
		<!--			&lt;!&ndash;					</div>&ndash;&gt;-->
		<!--			&lt;!&ndash;				</div>&ndash;&gt;-->
		<!--			&lt;!&ndash;				<form&ndash;&gt;-->
		<!--			&lt;!&ndash;					v-if="$can('update', searchPack)" class="wide mt-2"&ndash;&gt;-->
		<!--			&lt;!&ndash;					@submit.prevent="updateSearchPack()">&ndash;&gt;-->
		<!--			&lt;!&ndash;					<label><span>Bundle </span>&ndash;&gt;-->
		<!--			&lt;!&ndash;						<select v-model="form.data.bundle">&ndash;&gt;-->
		<!--			&lt;!&ndash;							<option disabled selected>—</option>&ndash;&gt;-->
		<!--			&lt;!&ndash;							<option&ndash;&gt;-->
		<!--			&lt;!&ndash;								v-for="(bundle, bundleIndex) in form.options.bundles"&ndash;&gt;-->
		<!--			&lt;!&ndash;								:key="bundleIndex"&ndash;&gt;-->
		<!--			&lt;!&ndash;								:value="bundle.id" v-html="bundle.name"/>&ndash;&gt;-->
		<!--			&lt;!&ndash;						</select>&ndash;&gt;-->
		<!--			&lt;!&ndash;					</label>&ndash;&gt;-->
		<!--			&lt;!&ndash;				</form>&ndash;&gt;-->
		<!--			&lt;!&ndash;			</template>&ndash;&gt;-->
		<!--			<table>-->
		<!--				<thead>-->
		<!--					<tr>-->
		<!--						<th align="left">Product</th>-->
		<!--						<th align="center">Status</th>-->
		<!--						<th align="right" class="actions"><span>Actions</span></th>-->
		<!--					</tr>-->
		<!--					<tr>-->
		<!--						<td>Land Registry Plan</td>-->
		<!--						<td align="center">-->
		<!--							<status-badge group="search-pack" status="complete"/>-->
		<!--						</td>-->
		<!--						<td align="right">-->
		<!--							<button-->
		<!--								class="button&#45;&#45;icon icon&#45;&#45;view"-->
		<!--								@click.prevent="viewFile('storage/demo/search-pack/Land Registry Plan.pdf')">View-->
		<!--							</button>-->
		<!--						</td>-->
		<!--					</tr>-->
		<!--					<tr>-->
		<!--						<td>OneSearch Search Pledge</td>-->
		<!--						<td align="center">-->
		<!--							<status-badge group="search-pack" status="complete"/>-->
		<!--						</td>-->
		<!--						<td align="right">-->
		<!--							<button-->
		<!--								class="button&#45;&#45;icon icon&#45;&#45;view"-->
		<!--								@click.prevent="viewFile('storage/demo/search-pack/OneSearch Search Pledge.pdf')">View-->
		<!--							</button>-->
		<!--						</td>-->
		<!--					</tr>-->
		<!--					<tr>-->
		<!--						<td>OneSearch Prime</td>-->
		<!--						<td align="center">-->
		<!--							<status-badge group="search-pack" status="pending"/>-->
		<!--						</td>-->
		<!--						<td align="right">-->
		<!--							&lt;!&ndash;							<button&ndash;&gt;-->
		<!--							&lt;!&ndash;								class="button button&#45;&#45;primary&#45;&#45;small"&ndash;&gt;-->
		<!--							&lt;!&ndash;								@click.prevent="viewFile('storage/demo/search-pack/OneSearch Prime.pdf')">View&ndash;&gt;-->
		<!--							&lt;!&ndash;							</button>&ndash;&gt;-->
		<!--						</td>-->
		<!--					</tr>-->
		<!--					<tr>-->
		<!--						<td>LandMark RiskView Residential</td>-->
		<!--						<td align="center">-->
		<!--							<status-badge group="search-pack" status="pending"/>-->
		<!--						</td>-->
		<!--						<td align="right">-->
		<!--							&lt;!&ndash;							<button&ndash;&gt;-->
		<!--							&lt;!&ndash;								class="button button&#45;&#45;primary&#45;&#45;small"&ndash;&gt;-->
		<!--							&lt;!&ndash;								@click.prevent="viewFile('storage/temp/OS Pledge.pdf')">View&ndash;&gt;-->
		<!--							&lt;!&ndash;							</button>&ndash;&gt;-->
		<!--						</td>-->
		<!--					</tr>-->
		<!--					<tr>-->
		<!--						<td>OneSearch NSR Chancel Insurance</td>-->
		<!--						<td align="center">-->
		<!--							<status-badge group="search-pack" status="pending"/>-->
		<!--						</td>-->
		<!--						<td align="right">-->
		<!--							&lt;!&ndash;							<button&ndash;&gt;-->
		<!--							&lt;!&ndash;								class="button button&#45;&#45;primary&#45;&#45;small"&ndash;&gt;-->
		<!--							&lt;!&ndash;								@click.prevent="viewFile('storage/temp/OS Prime.pdf')">View&ndash;&gt;-->
		<!--							&lt;!&ndash;							</button>&ndash;&gt;-->
		<!--						</td>-->
		<!--					</tr>-->
		<!--				</thead>-->
		<!--			</table>-->
		<!--		</template>-->
		<!--		<template v-slot:footer>-->
		<!--			<ul class="actions">-->
		<!--				<li>-->
		<!--					<button-->
		<!--						class="button button&#45;&#45;secondary" @click.prevent="$vmodal.close()">Close-->
		<!--					</button>-->
		<!--				</li>-->
		<!--				<li v-if="$can('update', searchPack)">-->
		<!--					<process-button-->
		<!--						:processing="form.processing" class="button button&#45;&#45;primary" text="Update"-->
		<!--						@click="updateSearchPack()"/>-->
		<!--				</li>-->
		<!--			</ul>-->
		<!--		</template>-->
		<vFileUpload
			:max-k-b="10000"
			:post="route('instructions/:instruction/search-packs/:searchPack/file', [instruction, searchPack])"
			accept="application/pdf"
			v-on:succeeded="(response) => uploaded(response)"/>
	</v-modal>
</template>
<script>
import vFileUpload from "@/common/components/v-upload/v-file-upload.vue";

export default {
	components: {vFileUpload},
	computed: {
		searchPack() {
			return this.instruction.searchPack;
		},
	},

	props: {
		instruction: {
			required: true,
			type: Object,
		},
	},

	methods: {
		uploaded(response) {
			console.log(response);
		},
	},
};
</script>
